import { render, staticRenderFns } from "./survey-step-metabolic-syndrome.vue?vue&type=template&id=6c6d4482"
import script from "./survey-step-metabolic-syndrome.vue?vue&type=script&lang=js"
export * from "./survey-step-metabolic-syndrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports